$(function(){

  // $('.btn-quest').on('click', function (e) {
  //   e.preventDefault();
  //   var $button = $(this);
  //   $.get( $button.attr('href'), function( data ) {
  //     data = $(data);
  //     $("#entry-popup .custom-form").html(data.find(".custom-form"));
  //     $('#entry-popup').modal()
  //   });
  //   return false;
  // });

  $("body").on("submit", "#entry-popup form", function(e){

    var $form = $("#entry-popup form")
    $form.find('.btn-form').prop('disabled', true);
    $.ajax({
      type: "POST",
      url: $form.attr("action"),
      data: $form.serialize(), // serializes the form's elements.
      success: function(data)
      {
          data = $(data);
          if(data.find(".custom-form").html().length > 20){
            $("#entry-popup .custom-form").html(data.find(".custom-form"));
            $form.find('.btn-form').prop('disabled', false);
          }
          else{
            $("#entry-popup .custom-form").html(data.find(".header-text"));
            setTimeout(function() {
              $('#entry-popup').modal('hide');
            }, 2000);
          }
           }
         });
    e.preventDefault();
    return false;
  });
});